<template>
	<div class="m-portlet m-portlet--mobile">
		<div class="form-group m-form__group col-md-4 col-sm-12">
			<div class="input-group">
				<input v-model="username" type="text" class="form-control" placeholder="Tên tài khoản">
				<div class="input-group-append">
					<button @click="onRemoveDevice" class="btn btn-brand" type="button">Gỡ thiết bị</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from '../../utilities';

	export default {
		data(){
			let vm = this;

	        return {
	        	"username": "",
	        }
	    },

	    methods: {
	        onRemoveDevice: function(){
	        	window.axios.get("partner/remove-device?username="+this.username)
        				.then((res) => {
        					if(res.data.code != 0){
        						swal("Lỗi", res.data.msg, "error");
        						return;
        					}
        					console.log("remove-device", res.data);
							swal("", "Đã gỡ thiết bị cho tài khoản "+this.username+" thành công", "success");
        				})
        				.catch((error) => {

        				});
	        }
	    }
	}

</script>